module.exports = __webpack_public_path__ + "2be5dbc527b0ad9e3b55a9a39229d88e.svg";